import React from 'react';
import Button from '../../../components/ui/Button';
import ShoeItemCard from './ShoeItemCard';

const ItemsSection = ({ items, services, servicesLoading, servicesError, onAddItem, onUpdateItem, onRemoveItem, errors }) => {
  return (
    <div className="rounded-lg bg-card p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-xl font-bold text-foreground">세척 신발 정보</h2>
        <Button
          variant="outline"
          size="sm"
          iconName="Plus"
          iconPosition="left"
          onClick={onAddItem}
        >
          신발 추가
        </Button>
      </div>
      <div className="space-y-4">
        {servicesError && (
          <p className="text-sm text-error">{servicesError}</p>
        )}
        {items?.map((item, index) => (
          <ShoeItemCard
            key={item?.id}
            item={item}
            index={index}
            services={services}
            servicesLoading={servicesLoading}
            onUpdate={onUpdateItem}
            onRemove={onRemoveItem}
            showRemove={items?.length > 1}
          />
        ))}
      </div>
      {errors?.items && (
        <p className="mt-2 text-sm text-error">{errors?.items}</p>
      )}
    </div>
  );
};

export default ItemsSection;